import "./utilities_namespace.js";

// The locale to forward on Sparkle-bound data requests, or null for the
// default locale so those URLs stay param-free and page-cacheable. The server
// takes a request's locale from its path prefix or its `?locale=` param alone,
// so the param is the only carrier for a data request. Where the embed bundle
// is loaded, its resolver decides (`Sparkle.Embed.Utilities.currentLocale`),
// since only it knows whether a host page's path carries a locale. Otherwise
// reads, in order, the page's `?locale=` param, its locale path prefix, the locale
// the server published to `window.Sparkle.locale`, and the `<html lang>` the server
// rendered. Unknown values are dropped.
window.Sparkle.Utilities.requestLocale = function () {
  var AVAILABLE_LOCALES = window.SparkleConfig?.locales?.available ?? [];
  var DEFAULT_LOCALE = window.SparkleConfig?.locales?.default ?? "en";

  if (window.Sparkle.Embed?.Utilities?.currentLocale) {
    return window.Sparkle.Embed.Utilities.currentLocale();
  }

  var locale = [localeFromUrl(), localeFromPath(), window.Sparkle.locale, document.documentElement.lang].find(
    function (candidate) {
      return AVAILABLE_LOCALES.indexOf(candidate) !== -1;
    },
  );

  if (!locale || locale === DEFAULT_LOCALE) {
    return null;
  }

  return locale;

  // The first path segment when it names an available locale: `/es/physicians/jane-doe` → "es".
  function localeFromPath() {
    var segment = window.location.pathname.split("/")[1];

    return AVAILABLE_LOCALES.indexOf(segment) === -1 ? null : segment;
  }

  function localeFromUrl() {
    try {
      return new URL(window.location.href).searchParams.get("locale");
    } catch (error) {
      return null;
    }
  }
};
